export function isInputFocused(): boolean {
  const active = document.activeElement
  return !!(
    active &&
    (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA' || active.getAttribute('contenteditable') === 'true')
  )
}

// A key event from a native text field belongs to that field — a window-level
// hotkey must not steal it (HIG-5238). Deliberately excludes contentEditable:
// the action body editor relies on capture-phase ⌘↵ listeners winning over its
// own Mod-Enter binding.
export function isNativeTextEntryTarget(target: EventTarget | null): boolean {
  const tagName = (target as Partial<Element> | null)?.tagName
  return tagName === 'TEXTAREA' || tagName === 'INPUT'
}

export function isInteractiveFocused(): boolean {
  if (isInputFocused()) return true
  const active = document.activeElement
  return !!(active && (active.tagName === 'BUTTON' || active.getAttribute('role') === 'button'))
}
